import { render } from "./HeaderView.vue?vue&type=template&id=87c9520e"
import script from "./HeaderScript.vue?vue&type=script&lang=js&external"
export * from "./HeaderScript.vue?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__